import React from 'react';

const Facebook = ({...props}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
    <path fill="#FFF" d="M10 10.807h1.815V9.043c0-.778.02-1.978.585-2.722C12.995 5.535 13.812 5 15.218 5c2.29 0 3.255.326 3.255.326l-.454 2.69s-.757-.219-1.462-.219c-.707 0-1.339.253-1.339.96v2.05h2.895l-.202 2.628h-2.693v9.126h-3.403v-9.126H10v-2.628"/>
  </svg>
);

export default Facebook;